var _path, _path2, _path3, _path4, _path5, _path6, _circle, _circle2, _circle3, _circle4, _circle5, _circle6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIlEvents1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 547,
    height: 520,
    viewBox: "0 0 547 520",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M382 241.5L153.5 241.5C109.317 241.5 73.5 277.317 73.5 321.5L73.5 516",
    stroke: "#38F9C5",
    strokeWidth: 7,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M347.5 210L151 210C89.1441 210 39 260.144 39 322L39 484.5",
    stroke: "#38F9C5",
    strokeWidth: 7,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M312.5 178L147 178C68.0233 178 4.00002 242.023 4.00001 321L4 452.5",
    stroke: "#38F9C5",
    strokeWidth: 7,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M165.5 277H394C438.183 277 474 241.183 474 197V2.5",
    stroke: "#5C1FDE",
    strokeWidth: 7,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M200 308.5H396.5C458.356 308.5 508.5 258.356 508.5 196.5V34",
    stroke: "#5C1FDE",
    strokeWidth: 7,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M235 340.5H400.5C479.477 340.5 543.5 276.477 543.5 197.5V66",
    stroke: "#5C1FDE",
    strokeWidth: 7,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 339,
    cy: 178,
    r: 12,
    fill: "#38F9C5"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 374,
    cy: 210,
    r: 12,
    fill: "#38F9C5"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 409,
    cy: 242,
    r: 12,
    fill: "#38F9C5"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 143,
    cy: 276,
    r: 12,
    fill: "#5C1FDE"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 177,
    cy: 308,
    r: 12,
    fill: "#5C1FDE"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 212,
    cy: 340,
    r: 12,
    fill: "#5C1FDE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIlEvents1);
export default __webpack_public_path__ + "static/media/il_events1.9275fc05c8e77ee63c55e79be22ce612.svg";
export { ForwardRef as ReactComponent };